export const fncEmptyVendors = (state, payload) => {
	state.vendorList = [];
}

export const fncSetVendors = (state, payload) => {
	state.vendorList = payload;
}

export const objVendorEdit = (state, payload) => {

	var savedRanges = [];
	for (var r in payload.vendor.ranges) {
		var savedRange = payload.vendor.ranges[r].range;
		var toPush = { headName: payload.vendor.ranges[r].manufacturer_name, id32: payload.vendor.ranges[r].range, name: payload.vendor.ranges[r].range_name };
    savedRanges.push( toPush );
		/*for (var sr in payload.spineRanges) {
			if (payload.spineRanges[sr].id32 == savedRange) {
				payload.spineRanges[sr].headName = payload.vendor.ranges[r].manufacturer_name;
				savedRanges.push(payload.spineRanges[sr]);
			}
		}*/
	}

	payload.vendor.savedRanges = savedRanges;

	var res = {};
	for (let d = 0; d < savedRanges.length; d++) {
		let doc = savedRanges[d];
		if (res[doc.headName] === undefined) {
			res[doc.headName] = []
		}
		res[doc.headName].push(doc);
	}

	payload.vendor.objList = res;

	if (payload.vendor.pdf_settings == '' || payload.vendor.pdf_settings == null) {
		var newSettings = [
			{ key: 'one', label: 'One', status: false, altLabel: '' },
			{ key: 'two', label: 'Two', status: false, altLabel: '' },
			{ key: 'three', label: 'Three', status: false, altLabel: '' },
		];
		payload.vendor.pdf_settings = newSettings;
	} else {
		payload.vendor.pdf_settings = JSON.parse(payload.vendor.pdf_settings)
	}
	state.objVendorEdit = payload.vendor;

}

export const fncResetObjList = (state, payload) => {
	var toReturn = state.objVendorEdit.savedRanges;
	var res = {};
	for (let d = 0; d < toReturn.length; d++) {
		let doc = toReturn[d];
		if (res[doc.headName] === undefined) {
			res[doc.headName] = []
		}
		res[doc.headName].push(doc);
	}
	var oldVendorEdit = state.objVendorEdit;
	var newObjList = [];
	for (var x in oldVendorEdit) {
		if (x == 'objList') {
			newObjList[x] = res;
		} else if (x == 'savedRanges') {
			newObjList[x] = toReturn;
		} else {
			newObjList[x] = oldVendorEdit[x];
		}
	}
	state.objVendorEdit = [];
	state.objVendorEdit = newObjList;
}

export const fncChangeObjList = (state, payload) => {

	var toReturn = [];
	for ( var y in state.objVendorEdit.savedRanges ) {
		if (state.objVendorEdit.savedRanges[y].id32 != payload ) {
			toReturn.push(state.objVendorEdit.savedRanges[y]);
		}
	}
	var res = {};
	for (let d = 0; d < toReturn.length; d++) {
		let doc = toReturn[d];
		if (res[doc.headName] === undefined) {
			res[doc.headName] = []
		}
		res[doc.headName].push(doc);
	}
	var oldVendorEdit = state.objVendorEdit;
	var newObjList = [];
	for (var x in oldVendorEdit) {
		if ( x == 'objList' ) {
			newObjList[x] = res;
		} else if ( x == 'savedRanges' ) {
			newObjList[x] = toReturn;
		} else {
			newObjList[x] = oldVendorEdit[x];
		}
	}
	state.objVendorEdit = [];
	state.objVendorEdit = newObjList;
}

export const fncSetVendorManufacturers = (state, payload) => {
	state.vendorManufacturers = payload;
}

export const fncSetManufacturerRanges = (state, payload) => {
	for ( var r in payload.ranges ) {
        payload.ranges[r].headName = payload.name
	}
	state.vendorManufacturerRanges = payload.ranges;
}

export const fncEmptyVendorRange = (state, payload) => {
	state.objVendorEdit.savedRanges = [];
}

export const fncSetManufacturerVendors = (state, payload) => {
	if (payload != '') {
		setTimeout(function () {
			state.vendorManufacturerLinks = payload;
		}, 1000);
	}
	if ( payload.length > 0 ) {
		state.vendorsIni = 1;
	}
}

export const fncSetVendorSelectEdit = (state, payload) => {
	state.objVendorSelectEdit = payload;
}

export const setOjAppRanges = (state, payload) => {
	state.objAppRanges = payload;
}

export const fncSetupAssign = (state, payload) => {

	var linkedVendors = [];
	var addedVendors = [];

	for (var v in state.vendorList) {
		for (var vr in state.vendorList[v].ranges) {
			var vRange = state.vendorList[v].ranges[vr].range;
			for (var p in payload.vendors) {
				if (payload.vendors[p].id32 == vRange) {
					state.vendorList[v].setEmail = state.vendorList[v].email;
					linkedVendors.push(state.vendorList[v]);
				}
			}
		}
	}

  for( var v in state.vendorList ) {
    if( state.vendorList[v].manufacturer == payload.manufacturer && state.vendorList[v].product_codes.length > 0 ) {
      linkedVendors.push(state.vendorList[v]);
    }
  }

	for ( var l in linkedVendors ) {
		for (v in state.vendorManufacturerLinks ) {
			if (linkedVendors[l].id == state.vendorManufacturerLinks[v].vendorId) {
				linkedVendors[l].setEmail = state.vendorManufacturerLinks[v].rangeEmail;
				linkedVendors[l].setReference = state.vendorManufacturerLinks[v].reference;
			}
		}
	}

	var finalVendors = [];

	for (var v in linkedVendors) {
		if (addedVendors.indexOf(linkedVendors[v].id ) == -1 ) {
			finalVendors.push(linkedVendors[v]);
			addedVendors.push(linkedVendors[v].id);
		}
	}

    state.vendorManufacturerLinks = finalVendors;
	//state.vendorManufacturerLinks = linkedVendors;
}

export const fncUpdateVendorLink = (state, payload) => {
	if (payload.ctype == 'reference') {
		state.vendorManufacturerLinks[payload.index].setReference = payload.value;
	} else if (payload.ctype == 'email') {
		state.vendorManufacturerLinks[payload.index].setEmail = payload.value;
	}
}

export const fncSetIni = (state, payload) => {
	state.vendorsIni = 1;
}

export const fncSetVendorDepartmentBranches = (state, payload) => {
  state.vendorDepartmentBranches = payload;
}
